// extracted by mini-css-extract-plugin
export default {"wrapper":"maskAnimation__wrapper__X1rSW","background":"maskAnimation__background__YjlUR","hidden":"maskAnimation__hidden__P0aLi"};